import { useEffect } from 'react';

/**
 * Locks body scroll when a modal is open and restores it on close.
 * @param {boolean} isOpen - Whether the modal is visible
 */
export function useModalScrollLock(isOpen) {
  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);
}
